import { PATH_PROXY_LOCAL, PATH_WP_LOCAL, PATH_WP } from ".";

export const BASE_PATH_WP = ([route]) => `${PATH_WP}/${route}`;
export const BASE_PATH_PROXY = ([route]) => `${PATH_WP}/${route}`;
export const SAME_URL = ([route]) => `${window.location.origin}/${route}`;
